import { callApi, callApiWithoutToken } from './api';

import { ApiResult } from '@/types/api';
import { SupportRecord, UpdateSupportRecordInput } from '@/types/supportRecord';

export type SupportRecordInput = {
  /* 管理者とスタッフ両方が記録するためIDはメールアドレスから取得 */
  recorder_email: string;
  start_time?: string;
  end_time?: string;
  attendance_status: 'absent' | 'attend';
  absent_date?: string;
  absent_reason_by_guardian?: string;
  absent_reason_by_staff?: string;
  is_rescheduled?: boolean;
  rescheduled_date?: string;
  is_absent_addition?: boolean;
  pickup_or_arrival_time?: string;
  is_pickup_addition?: boolean;
  dropoff_or_departure_time?: string;
  is_dropoff_addition?: boolean;
  body_temperature?: number;
  condition?: string;
  support_content?: string;
  staff_message?: string;
  staff_report?: string;
  support_record_images?: string[];
};

export const getSupportRecordByReservationID = async (
  reservation_id: number
): Promise<ApiResult<SupportRecord>> => {
  const { status, result } = await callApi<SupportRecord>(
    `attendance-reservations/${reservation_id}/support-record`,
    'GET',
    undefined,
    undefined,
    undefined,
    undefined,
    true
  );
  return { status, result };
};

export const createSupportRecord = async (
  reservation_id: number,
  input: SupportRecordInput
): Promise<ApiResult<SupportRecord>> => {
  const { status, result } = await callApi<SupportRecord>(
    `attendance-reservations/${reservation_id}/support-record`,
    'POST',
    undefined,
    input,
    undefined,
    undefined,
    true
  );
  return { status, result };
};

export const updateSupportRecord = async (
  reservation_id: number,
  input: SupportRecordInput
): Promise<ApiResult<SupportRecord>> => {
  const { status, result } = await callApi<SupportRecord>(
    `attendance-reservations/${reservation_id}/support-record`,
    'PUT',
    undefined,
    input,
    undefined,
    undefined,
    true
  );
  return { status, result };
};

export const getLineSupportRecordByReservationID = async (
  reservation_id: number,
  accessToken: string
): Promise<ApiResult<SupportRecord>> => {
  const { status, result } = await callApiWithoutToken<SupportRecord>(
    `line/attendance-reservations/${reservation_id}/support-record`,
    'GET',
    accessToken
  );
  return { status, result };
};

export const getSupportRecordsByChildID = async (
  lineID: string,
  accessToken: string,
  child_id: number,
  year: number
): Promise<ApiResult<SupportRecord[]>> => {
  const query = new URLSearchParams();
  query.append('year', year.toString());

  const { status, result } = await callApiWithoutToken<SupportRecord[]>(
    `line/${lineID}/children/${child_id}/support-record`,
    'GET',
    accessToken,
    query
  );
  return { status, result };
};

export const patchSupportRecord = async (
  lineID: string,
  accessToken: string,
  reservation_id: number,
  guardianMessage: string
): Promise<ApiResult<SupportRecord>> => {
  const { status, result } = await callApiWithoutToken<SupportRecord>(
    `line/${lineID}/attendance-reservations/${reservation_id}/support-record`,
    'PATCH',
    accessToken,
    undefined,
    { guardianMessage: guardianMessage }
  );
  return { status, result };
};

export const updateStaffSupportRecord = async (
  lineID: string,
  accessToken: string,
  office_id: string,
  reservation_id: number,
  input: UpdateSupportRecordInput
): Promise<ApiResult<UpdateSupportRecordInput>> => {
  const { status, result } = await callApiWithoutToken<UpdateSupportRecordInput>(
    `line/${lineID}/staff/offices/${office_id}/attendance-reservations/${reservation_id}/support-record`,
    'PUT',
    accessToken,
    undefined,
    input
  );
  return { status, result };
};

export const createStaffSupportRecord = async (
  lineID: string,
  accessToken: string,
  office_id: string,
  reservation_id: number,
  input: UpdateSupportRecordInput
): Promise<ApiResult<UpdateSupportRecordInput>> => {
  const { status, result } = await callApiWithoutToken<UpdateSupportRecordInput>(
    `line/${lineID}/staff/offices/${office_id}/attendance-reservations/${reservation_id}/support-record`,
    'POST',
    accessToken,
    undefined,
    input
  );
  return { status, result };
};
